import React from 'react'

type Props = {
    selector: string
    horizontalAlignment?: ScrollLogicalPosition
    verticalAlignment?: ScrollLogicalPosition
    className?: string
    onClick?: () => void
    children: React.ReactNode
}

const SmoothScrollLink = ({
    children,
    selector,
    horizontalAlignment = 'center',
    verticalAlignment = 'nearest',
    className,
    onClick,
}: Props) => {
    const scrollIntoView = () => {
        const el = document.querySelector(selector)
        el?.scrollIntoView({
            behavior: 'smooth',
            block: verticalAlignment,
            inline: horizontalAlignment,
        })
    }

    return (
        <a
            href={selector}
            onClick={(e) => {
                e.preventDefault()
                scrollIntoView()
                onClick?.()
            }}
            className={className}
        >
            {children}
        </a>
    )
}

export default SmoothScrollLink
